module.exports = __webpack_public_path__ + "img/hat_male_beanie.6694a88a.png";